//import Vue from 'vue'
import Router from 'vue-router'
import app from './app';
import h5 from './h5';
import common from './common';
import teacher from './teacher';



Vue.use(Router)

export default new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        ...app,
        ...teacher,
        ...h5,
        ...common
    ]
})